import React from 'react';
import styled from 'styled-components';
import { PieChart, Pie, Cell, Legend } from 'recharts';
import {
  Link,
} from "react-router-dom";


const COLORS = ['#4285F4', '#EA4335', '#FBBC05'];
const MyPie = styled.div`
  width: 100%;
  height: 100%;


  display: flex;
  flex-direction: column;

  align-items: center;
`
  const Title = styled(Link)`
    outline: none;
    text-decoration: none;
    color: #373D3F;
    font-size: 1.2em;
    font-weight: 400; 
    letter-spacing: 0.05em;
    padding-top: 0.5rem;
    z-index: -100;
  `

  const PieChartWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  `


function createData(database) {
  return [
    {'name': database.columns['column-1'].title, 'value': database.columns['column-1'].taskIds.length},
    {'name': database.columns['column-2'].title, 'value': database.columns['column-2'].taskIds.length},
    {'name': database.columns['column-3'].title, 'value': database.columns['column-3'].taskIds.length},
  ]
}

export default function Tasks ({tasks}) {

  const data = createData(tasks)

  return (
    <MyPie>
      <Title to={'/tasks'}>Tasks</Title>
      <PieChartWrapper>
        <PieChart width={310} height={270}>
          <Pie
            data={data}
            cy={115}
            innerRadius={60}
            outerRadius={85}
            fill="#8884d8"
            paddingAngle={1}
            dataKey="value"
            label
            labelLine={false}
          >
            {
              data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
          </Pie>
          <Legend/>
        </PieChart>
      </PieChartWrapper>
    </MyPie>
  )
}

